import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ReactApexChart from 'react-apexcharts'
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import {options, series} from "views/MainPage/Sections/Project.js";
import {bar_options, bar_series} from "views/MainPage/Sections/Budget.js";
import { API_BASE_URL } from "views/api"

const useStyles = makeStyles(styles);

const resource_map = {
  project: {
    'bhaktapur_ddc' : API_BASE_URL + 'homepage/projects/?administrative_unit=bhaktapur_district',
    'changunarayan_municipality' : API_BASE_URL + 'homepage/projects/?administrative_unit=changunarayan',
    'bhaktapur_municipality' : API_BASE_URL + 'homepage/projects/?administrative_unit=bhaktapur',
    'madhyapur_thimi_municipality' : API_BASE_URL + 'homepage/projects/?administrative_unit=madhyapur_thimi',
    'suryabinayak_municipality' : API_BASE_URL + 'homepage/projects/?administrative_unit=suryabinayak',
  },
  budget: {
    'bhaktapur_ddc' : API_BASE_URL + 'homepage/budgets/?administrative_unit=bhaktapur_district',
    'changunarayan_municipality' : API_BASE_URL + 'homepage/budgets/?administrative_unit=changunarayan',
    'bhaktapur_municipality' : API_BASE_URL + 'homepage/budgets/?administrative_unit=bhaktapur',
    'madhyapur_thimi_municipality' : API_BASE_URL + 'homepage/budgets/?administrative_unit=madhyapur_thimi',
    'suryabinayak_municipality' : API_BASE_URL + 'homepage/budgets/?administrative_unit=suryabinayak',
  },
  title: {
      bhaktapur_ddc : 'जि स स भक्तपुर',
    	changunarayan_municipality : 'चाँगुनारायण नगरपालिका',
    	bhaktapur_municipality : 'भक्तपुर नगरपालिका',
    	madhyapur_thimi_municipality : 'मध्यपुर थिमि नगरपालिका',
    	suryabinayak_municipality : 'सूर्यविनायक नगरपालिका'
  }
}

export const title_map = {
  bhaktapur_district : {
    name: 'जि स स भक्तपुर',
  },
  changunarayan : {
    name: 'चाँगुनारायण नगरपालिका',
  },
  bhaktapur : {
    name: 'भक्तपुर नगरपालिका',
  },
  madhyapur_thimi : {
    name: 'मध्यपुर थिमि नगरपालिका',
  },
  suryabinayak: {
    name:'सूर्यविनायक नगरपालिका'
  }
}


const FISCAL_YEAR_STRING = {
    '1': '2075/76',
    '2': '2076/77',
    '3': '2077/78',
    '4': '2078/79',
    '5': '2079/80',
    '6': '2080/81',
    '7': '2081/82',
    '8': '2082/83',
    '9': '2083/84',
    '10': '2084/85'
}


export default function ProductSection(props) {
  const classes = useStyles();

  const [budget_insights, setBudgetInsight] = React.useState(undefined);
  const [project_insights, setProjectInsight] = React.useState(undefined);

  React.useEffect(() => {
    if (project_insights === undefined) {
      fetch(resource_map.project[props.selection])
        .then(results => results.json())
        .then(data => {
            setProjectInsight(data.results);
        });
    }
  });

  React.useEffect(() => {
    if (budget_insights === undefined) {
      fetch(resource_map.budget[props.selection])
        .then(results => results.json())
        .then(data => {
            setBudgetInsight(data.results);
        });
    }
  });

  let administrative_units = []
  let fiscal_year = ''
  let budgets_data_income = []
  let budgets_data_expense = []

  if (budget_insights && budget_insights.length > 0) {
    administrative_units = budget_insights.map(b=>title_map[b.administrative_unit].name)
    fiscal_year = FISCAL_YEAR_STRING[budget_insights[0].fiscal_year]
    budgets_data_income = budget_insights.map(b=>b.total_estimated_income/10000000)
    budgets_data_expense = budget_insights.map(b=>b.total_estimated_expenditure/10000000)
  }

  let records = []

  const bar_colors = ['#173F5F', '#20639B', '#3CAEA3', '#F6D55C', '#ED553B']


  if (project_insights && project_insights.length > 0) {
    records = [
      { category : 'आर्थिक विकासका योजनाहरु', data : project_insights && project_insights[0].economic_development, color: bar_colors[0] },
      { category : 'पूर्वाधार विकासका योजनाहरु', data : project_insights && project_insights[0].infrastructure_development, color: bar_colors[1] },
      { category : 'सस्थागत विकास तर्फका योजनाहरु', data : project_insights && project_insights[0].institutional_development, color: bar_colors[2] },
      { category : 'सामाजिक विकासका योजनाहरु', data : project_insights && project_insights[0].social_development, color: bar_colors[3] },
      { category : 'अन्य योजनाहरु', data : project_insights && project_insights[0].other, color: bar_colors[4] }
    ]
  }

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>जानकारी</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>योजना, बजेट तथा कार्यक्रम</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <div style={{ color: '#333' }}>
            <GridContainer>
              <GridItem xs={12} sm={4} md={4} style={{margin:0, padding:0, float: 'left'}}>
                <table style={{width:"80%", margin: '20px'}}>
                  <tr>
                    <th><u>योजना को प्रकार</u></th>
                    <th><u>संख्या</u></th>
                  </tr>
                  {records.map((record, i) => {
                    return (
                      <tr style={{ height: '50px', backgroundColor: i%2 === 0 ? '#eee': '#fff' }}>
                        <td><div style={{ backgroundColor: record.color, height: '20px', width: '20px', float: 'left', marginLeft: '10px' }}/>{record.category}</td>
                        <td style={{ fontFamily: 'nepali-font' }}>{record.data}</td>
                      </tr>
                    )
                  })}
                </table>
              </GridItem>
              <GridItem xs={12} sm={4} md={3} style={{margin:0, padding:0, float: 'right'}}>
                {project_insights && <ReactApexChart options={options(resource_map.title[props.selection], records.map(r=>r.category))} series={series(records.map(r=>r.data))} type="bar" height={350} />}
              </GridItem>
              <GridItem xs={1} sm={1} md={1}/>
              <GridItem xs={11} sm={3} md={4} style={{margin:0, padding:0, float: 'right'}}>
                  <ReactApexChart options={bar_options(administrative_units, fiscal_year)} series={bar_series(budgets_data_income, budgets_data_expense)} type="bar" height={350} />
              </GridItem>
            </GridContainer>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
